import React, { useEffect, useState } from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap'
import { getUpdatedFilterLatest, onExport } from 'utils/helper';
import SearchContainer from './Reports/SearchContainer/Index';
import SearchContainerConfig from "./Configurations/SearchContainer/Index";
import ReportsTable from './Reports/ReportsTable/Index';
import { cloneDeep, find } from 'lodash';
import ConfigurationTable from './Configurations/ConfigurationsTable/index';
import plus from 'assets/icon/plus-icon.svg';
import Drawer from 'components/Drawer';
import AddConfigurations from './Configurations/AddConfigurations/Index';
import ManageNotifications from './NotificationCenter/ManageNotifications';
import useContextService from 'hooks/useContextService';
import useAxios from 'hooks/useAxios';

let filters = [];
let filterReports = []

let configdata = []
const ConfigurationsTabs = () => {
    const { token_type, access_token, profile } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const { roles } = profile || {};
    const [key, setkey] = useState('reports');
    const [tabKey, settabKey] = useState('configuration')
    const {
        states: { configuration, reports },
        setStates,
    } = useContextService();

    const API = useAxios();
    const [reset, setReset] = useState(false);
    const [collapseSider, setcollapseSider] = useState(false);
    const [selectedcoveredEntity, setselectedCoveredEntity] = useState(false)
    const { search, coveredEntity, searchTerms, claimStatusID } = configuration;
    const { Search, SearchTerms } = reports
    const [data, setData] = useState([])
    const [reportsdata, setReportsData] = useState([])
    const [notificationData, setNotificationData] = useState([])
    const [totalnotifcationReports, setTotalNotificationReports] = useState(0)
    const [totalItem, setTotalItem] = useState(0);
    const [totalItemReport, setTotalItemReport] = useState(0);
    const [filtershow, setFilterShow] = useState(false)
    const [configFiltershow, setConfigFilterShow] = useState(false)
    const [startPage, setStartPage] = useState(null)
    const [reportStartPage, setReportStartPage] = useState(null)
    const [selectedValues, setSelectedValues] = useState({
        claimTypeDesc: '',
        frequencyDesc: '',
    });
    const [selectedStatusValues, setSelectedStatusValues] = useState('')
    const [openPharmacy, setOpenPharmacy] = useState(false);
    const [sort, setSort] = useState(false)
    const [application, setApplication] = useState([])
    const [sortConfig, setSortConfig] = useState(false)
    const [configLoading, setConfigLoading] = useState(false)
    const [notificationLoading, setNotificationLoading] = useState(false)


    const onKeyChange = (k) => {
        setkey(k);
        setReset(!reset);
        settabKey('configuration')
    }

    const onTabKeyChange =(k) =>{
        settabKey(k);

    }

    const manval = () => {
        setcollapseSider(!collapseSider);
    }

    const manvalPharmacy = () => {
        setOpenPharmacy(!openPharmacy);
    }

    useEffect(() => {
        fetchAppType()
    }, [])

    const fetchAppType = async () => {
        try {
            const { data } = await API.get('api/Report/getAppType', {
                hasDefaultURL: true,
            }
            );
            if (data) {
                setApplication(data)
            }
        }
        catch (error) {
            'failed to load data'
        }
    }

    const fetchConfiguration = async (filters) => {
        setConfigLoading(true);

        try {
            const { data } = await API.post(`api/Report/reportConfigGrid`, filters,
                {
                    hasDefaultURL: true,
                    hideLoader: true,
                });
            if (data) {
                configdata.push(data.items);
                setData(data.items)
                setTotalItem(data.totalRecords);
            } else {
                configdata = []
                setData([])
                setTotalItem(0);
            }
        } catch (error) { /* empty */ }
        finally {
            setConfigLoading(false);
        }
    };

    const fetchReports = async (filters) => {
        try {
            const { data } = await API.post(`api/Report/reportGrid`, filters,
                {
                    hasDefaultURL: true,
                }
            );
            if (data) {
                setReportsData(data?.items)
                setTotalItemReport(data.totalRecords);
            }
            else {
                setReportsData([])
                setData([])
                setTotalItemReport(0);
            }
        }
        catch (error) { }
    };

    const fetchNotificationData = async (filters) => {
        setNotificationLoading(true);
        try {
            const { data } = await API.post(`api/Report/notificationCenterGrid`, filters,
                {
                    hasDefaultURL: true,
                    hideLoader:true,
                }
            );
            if (data) {
                setNotificationData(data?.items)
                setTotalNotificationReports(data.totalRecords);
            }
            else {
                setNotificationData([])
                setTotalNotificationReports(0);
            }
        }
        catch (error) { /* empty */ }
        finally {
            setNotificationLoading(false);
        }
    };

    const handleSearch = async (filter, hasfilter) => {
        if (hasfilter == true) {
            filter.claimType = filter.claimType
            filter.frequency = filter.frequency
            filter.coveredEntityID = searchTerms.coveredEntityIDs
            filter.ApplicationId = searchTerms.ApplicationId
            filter.ReportTypeId = searchTerms.ReportTypeId
            configuration.search.currentPage = 1
        }
        const {
            coveredEntityID,
            ApplicationId,
            ReportTypeId,
            claimType,
            frequency
        } = filter;
        Object.keys(filter).map((key) => {
            const index = filters.findIndex(
                (item) => item.filterName === key && key != 'dateOfService'
            );
            filters.splice(index, 1);
        });
        // if (coveredEntityID) {
        //     filters = getUpdatedFilterLatest("CEID", coveredEntityID, filters)
        // }
        if (claimType) {
            filters = getUpdatedFilterLatest("ClaimType", claimType, filters)
        }
        if (frequency) {
            filters = getUpdatedFilterLatest('Frequency', frequency, filters)
        }
        const tableRes = document.querySelector('.table-responsive');
        tableRes.scrollLeft = 0;
        search.filters = filters;
        search.EncryptedApplicationId = searchTerms.ApplicationId
        search.encryptedReportTypeId = searchTerms.ReportTypeId
        search.encryptedCEID = searchTerms.coveredEntityIDs
         await Promise.all([
            fetchConfiguration(search),
            fetchNotificationData(search),
        ]);
    };

    const handelSearchReports = async (filter, hasfilter) => {
        if (hasfilter == true) {
            filter.status = filter.status
            filter.coveredEntityID = SearchTerms.coveredEntityIDs
            filter.ApplicationId = SearchTerms.ApplicationId
            filter.ReportTypeId = SearchTerms.ReportTypeId
            if (SearchTerms.ReportTypeId !== undefined || SearchTerms.ReportTypeId !== '') {
                filter.ReportTypeId = SearchTerms.ReportTypeId
            }
            if (SearchTerms.startDate !== '') {
                filter.StartDate = SearchTerms.startDate
            }
            if (SearchTerms.endDate !== '') {
                filter.EndDate = SearchTerms.endDate
            }
            reports.Search.currentPage = 1
        }
        const {
            coveredEntityID,
            ApplicationId,
            ReportTypeId,
            StartDate,
            EndDate,
            status,
        } = filter;
        Object.keys(filter).map((key) => {
            const index = filterReports.findIndex(
                (item) => item.filterName === key && key != 'dateOfService'
            );
            filterReports.splice(index, 1);
        });
        // if (coveredEntityID) {
        //     filterReports = getUpdatedFilterLatest("CEID", coveredEntityID, filterReports)
        // }
        if (StartDate) {
            const year = StartDate.getFullYear();
            const month = (StartDate.getMonth() + 1).toString().padStart(2, '0');
            const day = StartDate.getDate().toString().padStart(2, '0');
            let StartDateUTC = `${month},${day},${year}`
            filterReports = getUpdatedFilterLatest("FromDate", StartDateUTC, filterReports, "startDate")
        }
        if (EndDate) {
            const endYear = EndDate.getFullYear();
            const endmonth = (EndDate.getMonth() + 1).toString().padStart(2, '0');
            const endday = EndDate.getDate().toString().padStart(2, '0');
            let EndDateUTC = `${endmonth},${endday},${endYear}`
            filterReports = getUpdatedFilterLatest("ToDate", EndDateUTC, filterReports, "endDate")
        }

        if (status) {
            filterReports = getUpdatedFilterLatest("StatusID", status, filterReports)
        }
        const tableRes = document.querySelector('.table-responsive');
        tableRes.scrollLeft = 0;
        Search.filters = filterReports;
        Search.EncryptedApplicationId = SearchTerms.ApplicationId
        Search.encryptedReportTypeId = SearchTerms.ReportTypeId
        Search.encryptedCEID = SearchTerms.coveredEntityIDs
        await fetchReports(Search);
    };

    const handleReset = () => {
        setcollapseSider(false);
        setData([]);
        setConfigFilterShow(false)
        setTotalItem(0);
        setNotificationData([]);
        setTotalNotificationReports(0);
    };

    const handleResetReports = () => {
        setcollapseSider(false)
        setReportsData([]);
        setFilterShow(false)
        setTotalItemReport(0);
    };

    const handlecoveredEntity = () => {
        setselectedCoveredEntity((prev) => !prev)
    }

    const handlePageChange = (filter, haveColFilter) => {
        if (haveColFilter) {
            const filterObj = cloneDeep(search);
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            filterObj.currentPage = filter.currentPage;
            filterObj.pageSize = filter.pageSize;
            configuration.search.currentPage = filter.currentPage;
            configuration.search.pageSize = filter.pageSize;
            configuration.search = { ...configuration.search };
            fetchConfiguration(filterObj);
        }
        else {
            if (totalItem > 0)
                fetchConfiguration(filter);
            configuration.search = { ...configuration.search, ...filter };
        }
        setStates('configuration', configuration);
    };

    const handleReportPageChange = (filter, haveColFilter) => {
        if (haveColFilter) {
            const filterObj = cloneDeep(Search);
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            filterObj.currentPage = filter.currentPage;
            filterObj.pageSize = filter.pageSize;
            reports.Search.currentPage = filter.currentPage;
            reports.Search.pageSize = filter.pageSize;
            reports.Search = { ...reports.Search };
            fetchReports(filterObj);
        } else {
            if (totalItemReport > 0)
                fetchReports(filter);
            reports.Search = { ...reports.Search, ...filter };
        }
        setStates('reports', reports);
    };

    return (
        <div>
            <Container fluid className='my-3 bin_info' >
                <div className='border-0 shadow-top card' hidden={collapseSider} >
                    <div className='card-body'>
                        {(key == "configuration") ?
                            <div style={{ position: "relative" }}>
                                <Button style={{ padding: "10px 10px", position: "absolute", right: "0" }}
                                    color="primary"
                                    className="search"
                                    onClick={manvalPharmacy}
                                >
                                    <span className='right_5'> <img src={plus} alt="" /></span>
                                    Add
                                </Button>
                            </div>
                            : ""}
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => onKeyChange(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="reports" title="Reports">
                                <SearchContainer onSearchReports={handelSearchReports}
                                    onReset={handleResetReports}
                                    setFilterShow={setFilterShow}
                                    selectedcoveredEntity={selectedcoveredEntity}
                                    reportStartPage={reportStartPage}
                                    setReportStartPage={setReportStartPage}
                                    setSelectedValues={setSelectedStatusValues}
                                    setSort={setSort}
                                    application={application}
                                />
                            </Tab>
                            {(roles?.includes("ACM") || roles?.includes("SUPADM")) && 
                                <Tab eventKey="configuration" title="Configurations">
                                    <SearchContainerConfig onSearch={handleSearch}
                                        onReset={handleReset}
                                        selectedcoveredEntity={selectedcoveredEntity}
                                        setFilterShow={setConfigFilterShow}
                                        startPage={startPage}
                                        setSelectedValues={setSelectedValues}
                                        setStartPage={setStartPage}
                                        application={application}
                                        setSort={setSortConfig} />
                                </Tab>
                            
                            }
                        </Tabs>
                    </div>
                </div>
                <div className='border-0 shadow-top card mt-3'>
                    <div className='section-devider-border card-body'>
                        {key == "reports" ?
                            <ReportsTable manval={manval}
                                collapseSider={collapseSider}
                                filters={Search}
                                onPageChange={handleReportPageChange}
                                onSearch={handelSearchReports}
                                //onReset={handleResetReports}
                                setFilterShow={setFilterShow}
                                filtershow={filtershow}
                                totalSize={totalItemReport}
                                reportsdata={reportsdata}
                                reportStartPage={reportStartPage}
                                fetchReports={fetchReports}
                                selectedValues={selectedStatusValues}
                                setSelectedValues={setSelectedStatusValues}
                                setReportStartPage={setReportStartPage}
                                ceid={SearchTerms.coveredEntityIDs}
                                appid={SearchTerms.ApplicationId}
                                sort={sort}
                                setSort={setSort}
                            /> :
                            <Tabs
                             id="controlled-tab-example"
                            activeKey={tabKey}
                            onSelect={(k) => onTabKeyChange(k)}
                            className="mb-3">
                                <Tab eventKey="configuration" title="Configurations">
                                <ConfigurationTable
                                    manval={manval}
                                    collapseSider={collapseSider}
                                    data={data}
                                    filters={search}
                                    setFilterShow={setConfigFilterShow}
                                    filtershow={configFiltershow}
                                    onSearch={handleSearch}
                                    onPageChange={handlePageChange}
                                    totalSize={totalItem}
                                    fetchConfiguration={fetchConfiguration}
                                    startPage={startPage}
                                    setStartPage={setStartPage}
                                    selectedValues={selectedValues}
                                    setSelectedValues={setSelectedValues}
                                    ceid={searchTerms.coveredEntityIDs}
                                    appid={searchTerms.ApplicationId}
                                    sort={sortConfig}
                                    setSort={setSortConfig}
                                    manvalPharacy={manvalPharmacy}
                                    reportId={searchTerms.ReportTypeId}
                                    loading={configLoading && tabKey === 'configuration'}
                                /> 
                                </Tab>
                                <Tab eventKey ="notification" title="Notification Center">
                               <ManageNotifications
                                data={notificationData}
                                manval={manval}
                                collapseSider={collapseSider}
                                filters={search}
                                encryptedCEID={searchTerms.coveredEntityIDs}
                                applicationId={searchTerms.ApplicationId}
                                searchReportTypeId={searchTerms.ReportTypeId}
                                fetchNotificationData={fetchNotificationData}
                                loading={notificationLoading && tabKey === 'notification'}
                                />
                                </Tab>
                                </Tabs>
                        }
                    </div>
                </div>
            </Container>
            {key == "configuration" &&
                <Drawer
                    direction='end'
                    isOpen={openPharmacy}
                    toggle={manvalPharmacy}
                    size='lg'
                    title='Add Configuration'
                >
                    <AddConfigurations
                        manvalPharacy={manvalPharmacy}
                        onSearch={handleSearch}
                        onSave={handlecoveredEntity}
                        application={application}
                    />
                </Drawer>
            }
        </div>
    )
}

export default ConfigurationsTabs;